import { onlineManager, useMutation } from '@tanstack/react-query';
import posCreate, { posForm } from '../../api/mutations/pos';
import { posCreateSuccess } from '../../redux/auth/authSlice';
import { useAppDispatch } from '../../redux/hooks';

const usePos = () => {
  const dispatch = useAppDispatch();
  const { mutateAsync: createPos, isPending } = useMutation({
    mutationKey: ['pos_creation'],
    mutationFn: (data: posForm) => posCreate(data),
    onMutate: () => {
      if (!onlineManager.isOnline()) {
        throw new Error('network_offline');
      }
    },
    onSuccess: (data) => {
      dispatch(
        posCreateSuccess({
          pos: {
            ID: data.ID,
            name: data.name,
            number: data.number,
            storeId: data.storeId ?? '',
          },
        })
      );
    },
  });

  return { createPos, isPending };
};

export default usePos;
